// src/public/tests/WordAssociationTest.js
import { useState, useEffect } from 'react';
import {
    Paper, Box, Typography, Button, LinearProgress,
    RadioGroup, FormControlLabel, Radio, Stack, Alert
} from '@mui/material';
import { useTranslation } from 'react-i18next';

// Datos de las preguntas - ESPAÑOL
export const wordAssociationQuestionsES = [
    { id: 1, pair1: ["Esposo", "Esposa"], options: [["Primo", "Primo segundo"], ["Abuelo", "Abuela"], ["Hermano", "Hermana"], ["Tío", "Suegra"]], correctAnswer: 1 },
    { id: 2, pair1: ["Oveja", "Cordero"], options: [["León", "Selva"], ["Vaca", "Ternero"], ["Árbol", "Hoja"], ["Nube", "Lluvia"]], correctAnswer: 1 },
    { id: 3, pair1: ["Silla", "Mesa"], options: [["Computador", "Teclado"], ["Sol", "Luna"], ["Avión", "Ala"], ["Timón", "Silla del conductor"]], correctAnswer: 0 },
    { id: 4, pair1: ["Bolígrafo", "Tinta"], options: [["Lámpara", "Bombilla"], ["Pared", "Pintura"], ["Caja", "Tapa"], ["Reloj", "Pulsera"]], correctAnswer: 0 },
    { id: 5, pair1: ["Crema de dientes", "Cepillo de dientes"], options: [["Pan", "Horno"], ["Nube", "Lluvia"], ["Río", "Lago"], ["Mantequilla", "Pan"]], correctAnswer: 3 },
    { id: 6, pair1: ["Media", "Zapato"], options: [["Guante", "Mano"], ["Pantalones", "Blusa"], ["Piscina", "Nadador"], ["Kayak", "Remo"]], correctAnswer: 0 },
    { id: 7, pair1: ["Papel", "Lápiz"], options: [["Pared", "Pintura"], ["Libro", "Biblioteca"], ["Harina", "Pan"], ["Espagueti", "Salsa"]], correctAnswer: 0 },
    { id: 8, pair1: ["Estación de gasolina", "Automóvil"], options: [["Motocicleta", "Motociclista"], ["Barbero", "Persona"], ["Puerta principal", "Puerta trasera"], ["Almacenamiento", "Montacargas"]], correctAnswer: 1 },
    { id: 9, pair1: ["Internet", "Teléfono móvil"], options: [["Ratón", "Ratón de computador"], ["Casa", "Llave"], ["Impresora", "Papel para impresora"], ["Ventana", "Puerta"]], correctAnswer: 2 },
    { id: 10, pair1: ["Día", "Noche"], options: [["Frente", "Atrás"], ["Verano", "Invierno"], ["Frío", "Calor"], ["Norte", "Sur"]], correctAnswer: 1 },
    { id: 11, pair1: ["Enojado", "Feliz"], options: [["Cansado", "Animado"], ["Feliz", "Relajado"], ["Positivo", "Entretenido"], ["Decepcionado", "Nervioso"]], correctAnswer: 0 },
    { id: 12, pair1: ["Avión", "Buque"], options: [["Bicicleta", "Zapato"], ["Carro", "Llanta"], ["Tren", "Bus"], ["Tranvía", "Ferrocarril"]], correctAnswer: 2 },
    { id: 13, pair1: ["Papa", "Cebolla"], options: [["Manzana", "Naranja"], ["Piña", "Banano"], ["Pera", "Durazno"], ["Rábano", "Zanahoria"]], correctAnswer: 3 },
    { id: 14, pair1: ["Árbol", "Semilla"], options: [["Planta", "Fruta"], ["Pájaro", "Huevo"], ["Flor", "Pétalo"], ["Perro", "Cachorro"]], correctAnswer: 1 },
    { id: 15, pair1: ["Gato", "Ratón"], options: [["León", "Antílope"], ["Elefante", "Jirafa"], ["Vaca", "Oveja"], ["Zorro", "Oso"]], correctAnswer: 0 },
    { id: 16, pair1: ["Policía", "Juez"], options: [["Deportista", "Cocinero"], ["Contador", "Mesera"], ["Doctor", "Enfermera"], ["Arquitecto", "Abogado"]], correctAnswer: 2 },
];

// Datos de las preguntas - ENGLISH
export const wordAssociationQuestionsEN = [
    { id: 1, pair1: ["Husband", "Wife"], options: [["Cousin", "Second cousin"], ["Grandfather", "Grandmother"], ["Brother", "Sister"], ["Uncle", "Mother-in-law"]], correctAnswer: 1 },
    { id: 2, pair1: ["Sheep", "Lamb"], options: [["Lion", "Jungle"], ["Cow", "Calf"], ["Tree", "Leaf"], ["Cloud", "Rain"]], correctAnswer: 1 },
    { id: 3, pair1: ["Chair", "Table"], options: [["Computer", "Keyboard"], ["Sun", "Moon"], ["Airplane", "Wing"], ["Steering wheel", "Driver’s seat"]], correctAnswer: 0 },
    { id: 4, pair1: ["Pen", "Ink"], options: [["Lamp", "Bulb"], ["Wall", "Paint"], ["Box", "Lid"], ["Watch", "Strap"]], correctAnswer: 0 },
    { id: 5, pair1: ["Toothpaste", "Toothbrush"], options: [["Bread", "Oven"], ["Cloud", "Rain"], ["River", "Lake"], ["Butter", "Bread"]], correctAnswer: 3 },
    { id: 6, pair1: ["Sock", "Shoe"], options: [["Glove", "Hand"], ["Pants", "Blouse"], ["Pool", "Swimmer"], ["Kayak", "Paddle"]], correctAnswer: 0 },
    { id: 7, pair1: ["Paper", "Pencil"], options: [["Wall", "Paint"], ["Book", "Library"], ["Flour", "Bread"], ["Spaghetti", "Sauce"]], correctAnswer: 0 },
    { id: 8, pair1: ["Gas station", "Car"], options: [["Motorcycle", "Motorcyclist"], ["Barber", "Person"], ["Front door", "Back door"], ["Storage", "Forklift"]], correctAnswer: 1 },
    { id: 9, pair1: ["Internet", "Mobile phone"], options: [["Mouse", "Computer mouse"], ["House", "Key"], ["Printer", "Printer paper"], ["Window", "Door"]], correctAnswer: 2 },
    { id: 10, pair1: ["Day", "Night"], options: [["Front", "Back"], ["Summer", "Winter"], ["Cold", "Heat"], ["North", "South"]], correctAnswer: 1 },
    { id: 11, pair1: ["Angry", "Happy"], options: [["Tired", "Cheerful"], ["Happy", "Relaxed"], ["Positive", "Entertained"], ["Disappointed", "Nervous"]], correctAnswer: 0 },
    { id: 12, pair1: ["Airplane", "Ship"], options: [["Bicycle", "Shoe"], ["Car", "Tire"], ["Train", "Bus"], ["Tram", "Railroad"]], correctAnswer: 2 },
    { id: 13, pair1: ["Potato", "Onion"], options: [["Apple", "Orange"], ["Pineapple", "Banana"], ["Pear", "Peach"], ["Radish", "Carrot"]], correctAnswer: 3 },
    { id: 14, pair1: ["Tree", "Seed"], options: [["Plant", "Fruit"], ["Bird", "Egg"], ["Flower", "Petal"], ["Dog", "Puppy"]], correctAnswer: 1 },
    { id: 15, pair1: ["Cat", "Mouse"], options: [["Lion", "Antelope"], ["Elephant", "Giraffe"], ["Cow", "Sheep"], ["Fox", "Bear"]], correctAnswer: 0 },
    { id: 16, pair1: ["Police officer", "Judge"], options: [["Athlete", "Cook"], ["Accountant", "Waitress"], ["Doctor", "Nurse"], ["Architect", "Lawyer"]], correctAnswer: 2 },
];

const WordAssociationTest = ({
    responses,
    onAnswerChange,
    currentQuestion,
    onQuestionChange,
    onComplete,
    saving,
    language = 'es',
    timeRemaining = null
}) => {
    const { t } = useTranslation();
    const [selectedOption, setSelectedOption] = useState(null);

    // Seleccionar preguntas según idioma
    const wordAssociationQuestions = language === 'es'
        ? wordAssociationQuestionsES
        : wordAssociationQuestionsEN;

    const totalQuestions = wordAssociationQuestions.length;
    const progress = ((currentQuestion + 1) / totalQuestions) * 100;
    const question = wordAssociationQuestions[currentQuestion];

    // Cargar respuesta guardada cuando cambia la pregunta
    useEffect(() => {
        setSelectedOption(responses[question.id] ?? null);
    }, [currentQuestion, question.id, responses]);

    const handleOptionSelect = (optionIndex) => {
        setSelectedOption(optionIndex);
        // NO guardamos inmediatamente, solo actualizamos el estado local
    };

    const handleNext = () => {
        // Actualizar el estado del padre
        onAnswerChange(question.id, selectedOption);

        if (currentQuestion < totalQuestions - 1) {
            // Construir todas las respuestas incluyendo la actual
            const allResponses = { ...responses, [question.id]: selectedOption };
            onQuestionChange(currentQuestion + 1, allResponses);
        } else {
            const allResponses = { ...responses, [question.id]: selectedOption };
            onComplete(allResponses);
        }
    };

    const handleSkip = () => {
        // Guardar como null (omitida)
        onAnswerChange(question.id, null);
        setSelectedOption(null);

        if (currentQuestion < totalQuestions - 1) {
            const allResponses = { ...responses, [question.id]: null };
            onQuestionChange(currentQuestion + 1, allResponses);
        } else {
            const allResponses = { ...responses, [question.id]: null };
            onComplete(allResponses);
        }
    };

    const canGoNext = selectedOption !== null;
    const isTimeExpired = timeRemaining !== null && timeRemaining <= 0;

    // Opciones en formato "A.", "B.", etc.
    const optionLabels = ['A', 'B', 'C', 'D'];

    return (
        <Paper elevation={3} sx={{ p: 4 }}>
            {/* Header con progreso */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    {t('reasoningTests.questionProgress', {
                        current: currentQuestion + 1,
                        total: totalQuestions
                    })}
                </Typography>
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{ height: 8, borderRadius: 1 }}
                />
            </Box>

            {/* Mensaje de tiempo expirado */}
            {isTimeExpired && (
                <Alert severity="error" sx={{ mb: 3 }}>
                    {t('reasoningTests.timeExpired')}
                </Alert>
            )}

            {/* Pregunta */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h6" gutterBottom>
                    {t('reasoningTests.similarRelationTo')}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 3, color: 'primary.main' }}>
                    {question.pair1[0]} : {question.pair1[1]}
                </Typography>

                <RadioGroup
                    value={selectedOption !== null ? String(selectedOption) : ''}
                    onChange={(e) => handleOptionSelect(Number(e.target.value))}
                >
                    <Stack spacing={2}>
                        {question.options.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={String(index)}
                                disabled={isTimeExpired}
                                control={<Radio />}
                                label={
                                    <Typography variant="body1">
                                        <strong>{optionLabels[index]}.</strong> {option[0]} : {option[1]}
                                    </Typography>
                                }
                                sx={{
                                    border: 1,
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    p: 2,
                                    m: 0,
                                    '&:hover': {
                                        bgcolor: 'action.hover',
                                    },
                                }}
                            />
                        ))}
                    </Stack>
                </RadioGroup>
            </Box>

            {/* Botones de navegación */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
                <Button
                    variant="text"
                    onClick={handleSkip}
                    disabled={saving || isTimeExpired}
                >
                    {t('reasoningTests.skipQuestion')}
                </Button>

                <Button
                    variant="contained"
                    onClick={handleNext}
                    disabled={!canGoNext || saving || isTimeExpired}
                    size="large"
                >
                    {currentQuestion === totalQuestions - 1
                        ? t('reasoningTests.finish')
                        : t('reasoningTests.next')
                    }
                </Button>
            </Box>

            {/* Indicador de guardado */}
            {saving && (
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: 'block', textAlign: 'center', mt: 2 }}
                >
                    {t('reasoningTests.savingProgress')}
                </Typography>
            )}
        </Paper>
    );
};

export default WordAssociationTest;